import { z } from "zod";
export var DmaParameterKind;
(function (DmaParameterKind) {
    DmaParameterKind["Constant"] = "Constant";
    DmaParameterKind["DependentVariable"] = "DependentVariable";
    DmaParameterKind["Derivative"] = "Derivative";
    DmaParameterKind["IndependentVariable"] = "IndependentVariable";
    DmaParameterKind["RangeParameter"] = "RangeParameter";
    DmaParameterKind["Variable"] = "Variable";
})(DmaParameterKind || (DmaParameterKind = {}));
export const dmaParameterKindDtoSchema = z.nativeEnum(DmaParameterKind);
